import { REASON_UNPOTENTIAL } from '@/modules/Business/types/utils'
import { Control, useWatch } from 'react-hook-form'
import { BusinessExplainationPayload } from '@/modules/Business/types/payload'
import { FormItem, Typogaphy } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'

interface ClosedExplainationProps {
    control: Control<BusinessExplainationPayload>
    disable?: boolean
}

const ClosedExplaination: React.FC<ClosedExplainationProps> = ({
    control,
    disable,
}) => {
    const { t } = useTranslation()
    const failedReason = useWatch({
        control,
        name: 'failed_reason',
    })

    const reasons = REASON_UNPOTENTIAL(t)
    const showExplanationInput = ['budget', 'provider', 'others'].includes(
        failedReason
    )

    const placeholderMap: Record<string, string> = {
        budget: t('business-budget-reason'),
        provider: t('business-provider-reason'),
        others: t('business-others-reason'),
    }

    return (
        <div className="mt-4">
            <Typogaphy className="font-medium" size="small">
                {t('business-result-closed-reason')}
            </Typogaphy>
            <FormItem
                control={control}
                direction="column"
                type="radiogroup"
                name="failed_reason"
                options={reasons}
                disabled={disable}
            />
            {showExplanationInput && (
                <div className="space-y-2 mt-2">
                    <FormItem
                        control={control}
                        name="failed_explanation"
                        type="textfield"
                        placeholder={placeholderMap[failedReason]}
                        disabled={disable}
                    />
                </div>
            )}
            <div className="space-y-2 mt-4">
                <FormItem
                    control={control}
                    name="failed_improvement"
                    type="textarea"
                    label={t('business-result-improvement')}
                    placeholder="N/A"
                    disabled={disable}
                />
            </div>
        </div>
    )
}

export default ClosedExplaination
